import BeeLink from './BeeLink';



export default BeeLink;
